/**
 * Copyright 2015 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* eslint-env browser */
'use strict';

if ('serviceWorker' in navigator) {
  // Delay registration until after the page has loaded, to ensure that our
  // precaching requests don't degrade the first visit experience.
  // See https://developers.google.com/web/fundamentals/instant-and-offline/service-worker/registration
  $('#radio-sw-support').prop('checked', true);
  window.addEventListener('load', function () {
    // Your service-worker.js *must* be located at the top-level directory relative to your site.
    // It won't be able to control pages unless it's located at the same level or higher than them.
    // *Don't* register service worker file in, e.g., a scripts/ sub-directory!
    // See https://github.com/slightlyoff/ServiceWorker/issues/468
    navigator.serviceWorker.register('service-worker.js').then(function (reg) {
      checkServiceWorker(reg);
      // updatefound is fired if service-worker.js changes.
      reg.onupdatefound = function () {
        // The updatefound event implies that reg.installing is set; see
        // https://slightlyoff.github.io/ServiceWorker/spec/service_worker/index.html#service-worker-container-updatefound-event
        var installingWorker = reg.installing;
        installingWorker.onstatechange = function () {
          switch (installingWorker.state) {
            case 'installed':
              $('#radio-sw-installed').prop('checked', true);
              if (navigator.serviceWorker.controller) {
                // At this point, the old content will have been purged and the fresh content will
                // have been added to the cache.
                // It's the perfect time to display a "New content is available; please refresh."
                // message in the page's interface.
                console.log('New or updated content is available.');
              } else {
                // At this point, everything has been precached.
                // It's the perfect time to display a "Content is cached for offline use." message.
                $('#radio-sw-offline').prop('checked', true);
                console.log('Content is now available offline!');
              }
              break;

            case 'redundant':
              console.error('The installing service worker became redundant.');
              break;
          }
        };
      };
    }).catch(function (e) {
      console.error('Error during service worker registration:', e);
    });
  });
} else {
  $('#radio-sw-support').prop('checked', true).addClass('denied');
}

// Your custom JavaScript goes here
/* eslint-env jquery */
var serviceWorker;
function checkServiceWorker(registration) {
  if (registration.installing) {
    serviceWorker = registration.installing;
  } else if (registration.waiting) {
    serviceWorker = registration.waiting;
    $('#radio-sw-installed').prop('checked', true);
  } else if (registration.active) {
    $('#radio-sw-installed').prop('checked', true);
    $('#radio-sw-offline').prop('checked', true);
    serviceWorker = registration.active;
  }
}
if (serviceWorker) {
  console.log(serviceWorker.state);
  serviceWorker.addEventListener('statechange', function (e) {
    console.log(e.target.state);
  });
}

$('document').ready(function () {

  if (!navigator.onLine) {
    $('#submit-button').text('Offline').fadeIn();
    $('#submit-button').toggleClass('loading');
  }

  $('#myForm').submit(function (e) {
    $('#submit-button').text('Sending...').fadeIn();
    $('#submit-button').toggleClass('loading');
  });

  $('iframe#gdocs').load(function () {
    $('#myForm')[0].reset();
    $('#submit-button').text('Thank you for contacting us').fadeIn();
    $('#submit-button').toggleClass('done');
    $('#submit-button').toggleClass('loading');

    setTimeout(function () {
      $('#submit-button').text('Submit').fadeIn();
      $('#submit-button').toggleClass('done');
    }, 3000);
  });

  window.addEventListener('offline', function (e) {
    console.log('offline');
    $('#submit-button').text('Offline').fadeIn();
    $('#submit-button').toggleClass('loading');
    showNotification('You are now offline', false);
  });
  window.addEventListener('online', function (e) {
    console.log('online');
    $('#submit-button').text('Send').fadeIn();
    $('#submit-button').removeClass('loading');
    showNotification('You are now online', false);
  });

  particlesJS.load('particles', 'images/particles/particlesjs-config.json', function () {
    // console.log('Particles.js loaded');
  });



  $('#btn-notification').click(function () {
    showNotification($('#notification-msg').val(), true)
  });

  if ('Notification' in window) {
    $('#radio-notification-support').prop('checked', true);
    checkNotificationPermission();
  } else {
    $('#radio-notification-support').prop('checked', true).addClass('denied');
    $('#btn-notification').addClass('disabled');
    $('#btn-notification').text('Not supported');
    $('#notification-msg').prop('disabled', true);
    $('#notification-msg').prop('placeholder', 'Notifications are not supported in your browser');
  }

  function checkNotificationPermission() {
    switch (Notification.permission) {
      case 'granted':
        $('#radio-notification-granted').prop('checked', true);
        break;
      case 'denied':
        $('#radio-notification-granted').prop('checked', true).addClass('denied');
        $('#btn-notification').addClass('disabled');
        $('#btn-notification').text('Permission denied');
        $('#notification-msg').prop('disabled', true);
        $('#notification-msg').prop('placeholder', 'Please allow notifications in your browser');
        break;
    }
  }

  function showNotification(message, shouldRequest) {
    if (shouldRequest) {
      Notification.requestPermission().then(function (result) {
        console.log(result);
        switch (result) {
          case 'granted':
            navigator.serviceWorker.ready.then(function (registration) {
              registration.showNotification('Onamis PWA', {
                body: message || 'This is a test notification!',
                icon: '../../images/icons/apple-touch-icon.png',
                vibrate: [200, 100, 200],
                tag: 'notification-sample'
              })
            });
            break;
          case 'denied':
            break;
        }
        checkNotificationPermission();
      });
    } else if (Notification.permission == 'granted') {
      navigator.serviceWorker.ready.then(function (registration) {
        registration.showNotification('Onamis PWA', {
          body: message || 'Internet status changed',
          icon: '../../images/icons/apple-touch-icon.png',
          tag: 'notification-internet'
        })
      });
    }
  }

});